import { createApiResource, UnpagedListResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { ServiceTitanAdjustableCapacityDTO, ServiceTitanAdjustableCapacityParams } from '../apiTypes.shim';

type ServiceTitanAdjustableCapacityResource = UnpagedListResource<
  ServiceTitanAdjustableCapacityDTO,
  ServiceTitanAdjustableCapacityParams
>;

export const createServiceTitanAdjustableCapacityResource = (
  companyId: string
): ServiceTitanAdjustableCapacityResource => {
  const uri = `${companyId}/adjustable-capacity`;
  const { unpagedListQueryKey, useUnpagedList, unpagedList } = createApiResource(ServiceTitanAPI, uri);
  return { unpagedListQueryKey, useUnpagedList, unpagedList };
};
